import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { 
  getFirestore, 
  enableIndexedDbPersistence, 
  CACHE_SIZE_UNLIMITED,
  connectFirestoreEmulator
} from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Your web app's Firebase configuration
// Replace with your actual Firebase config values if needed
const firebaseConfig = {
  apiKey: "AIzaSyCnyUMQccLOKp_E5JoQ50k0xVzkeAVrzIM",
  authDomain: "rank-the-blank.firebaseapp.com",
  projectId: "rank-the-blank",
  storageBucket: "rank-the-blank.firebasestorage.app",
  messagingSenderId: "682095647786",
  appId: "1:682095647786:web:69d7d2b140bd57be763753",
  measurementId: "G-GNTE2BFTZ5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// Enable debugging in non-production environments
if (process.env.NODE_ENV !== 'production') {
  console.log('Firebase debugging enabled in development environment');
  
  // Expose Firebase services to console for debugging
  if (typeof window !== 'undefined') {
    window.firebase = { 
      app, 
      auth, 
      db, 
      functions 
    };
  }
  
  // Configure Firestore for better debugging
  try {
    // Set Firestore settings
    db._settings = {
      ignoreUndefinedProperties: true,
      cacheSizeBytes: CACHE_SIZE_UNLIMITED
    };
    
    // Enable offline persistence for better dev experience
    enableIndexedDbPersistence(db).catch((err) => {
      if (err.code === 'failed-precondition') {
        console.warn('Firebase persistence could not be enabled: Multiple tabs open');
      } else if (err.code === 'unimplemented') {
        console.warn('Firebase persistence not available in this browser');
      } else {
        console.error('Error enabling Firebase persistence:', err);
      }
    });

    // Connect to emulators if REACT_APP_USE_FIREBASE_EMULATORS is set
    if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
      // Firestore emulator typically runs on port 8080
      connectFirestoreEmulator(db, 'localhost', 8080);
      // Functions emulator typically runs on port 5001
      connectFunctionsEmulator(functions, 'localhost', 5001);
      console.log('Connected to Firebase emulators');
    }
  } catch (err) {
    console.error('Error configuring Firestore:', err);
  }
}

// Add extra debugging logs for Firebase operations
const enhancedDb = {
  ...db,
  collection: (...args) => {
    console.debug('Firestore: Accessing collection', ...args);
    return db.collection(...args);
  },
  doc: (...args) => {
    console.debug('Firestore: Accessing document', ...args);
    return db.doc(...args);
  }
};

// Export initialized services
export { auth, db, functions };

// Export debug helpers
export const firebaseDebug = {
  logEvent: (name, details) => {
    console.debug(`Firebase Event: ${name}`, details);
  },
  clearPersistence: async () => {
    try {
      if (process.env.NODE_ENV !== 'production') {
        await db.clearPersistence();
        console.log('Firebase persistence cleared successfully');
        return true;
      }
      return false;
    } catch (err) {
      console.error('Error clearing Firebase persistence:', err);
      return false;
    }
  }
};